import React from 'react'

function DaillyNews() {
    return (
        <div>DaillyNews</div>
    )
}

export default DaillyNews